export default __webpack_public_path__ + "static/media/mpeg.fefdd5df.png";